export function isObjectRecord(
  value: unknown,
): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null
}

export function getUnknownProperty(value: unknown, key: string): unknown {
  if (!isObjectRecord(value)) {
    return undefined
  }
  return Reflect.get(value, key)
}

export function getStringProperty(
  value: unknown,
  key: string,
): string | undefined {
  const property = getUnknownProperty(value, key)
  return typeof property === 'string' ? property : undefined
}

export function getNumberProperty(
  value: unknown,
  key: string,
): number | undefined {
  const property = getUnknownProperty(value, key)
  return typeof property === 'number' ? property : undefined
}

export function extractTextValue(value: unknown): string | null {
  return typeof value === 'string' && value.trim().length > 0 ? value : null
}
